import Icon from '@ant-design/icons';
import classNames from 'classnames';

import ReferralSvg from '@/components/Icon/svgs/Referral.svg';
import GiftSvg from '@/components/Icon/svgs/gift_bring.svg';
import useStorage from '@/hooks/useStorage';
import { useTranslation } from '@/i18n/client';
import useReferral from '@/store/useReferralStore';
import { EVENT } from '@/utils/event';

import styles from '../../index.less';

interface IProps {}

const Referral: React.FC<IProps> = () => {
  const [layoutSecondaryPanel, setLayoutSecondaryPanel] =
    useStorage<string>('layoutSecondaryPanel');
  const referralData = useReferral((state) => state.data);
  const { t } = useTranslation();

  return (
    <div
      className={classNames(styles.menuItem, 'flex')}
      onClick={() => {
        dispatchEvent(new Event(EVENT.FOLD_MENU));
        layoutSecondaryPanel === 'bring'
          ? setLayoutSecondaryPanel('')
          : setLayoutSecondaryPanel('bring');
      }}
    >
      <div>
        <div className="flex justify-between items-center">
          <div>
            <Icon className={styles.icon} component={ReferralSvg} />
            <span className={styles.text}>{t('menu.bringYourFriends')}</span>
          </div>

          {!!referralData.unclaimRewardNum && (
            <div className="bg-gradient-to-b from-[#A99DF5] to-[#7B67EF] h-[146x] pr-[4px] pl-[6px] text-[#FEFDFF] flex items-center justify-center rounded-[24px] ml-[8px]">
              <Icon className="text-[12px]" component={GiftSvg} />
              <span className="text-[12px] scale-75">{t('menu.new')}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Referral;
